import React, { useState } from "react";
import "./index.scss";
import phone from "../../assets/phone.png";
import email from "../../assets/email.png";
import ContactService from "../../services/contact/contact.service";
import { showErrorToaster } from "../toaster/error";
import { showSuccessToaster } from "../toaster/success";
import StickyButton from "../StickyButton";
const contactService = new ContactService();
const ContactForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    type: "",
  });
  const [formErrors, setFormErrors] = useState();
  let label = {
    name: "Titre",
    email: "Email",
    phone: "Phone",
    type: "Type",
  };
  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData({ ...formData, [id]: value });
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    let error = false;
    let errors = {};
    if (!formData?.name || formData?.name === "") {
      error = true;
      errors[`name`] = "Champ obligatoire";
    }
    if (!formData?.email || formData?.email === "") {
      error = true;
      errors[`email`] = "Champ obligatoire";
    }

    if (!formData?.phone || formData?.phone === "") {
      error = true;
      errors[`phone`] = "Champ obligatoire";
    }

    if (!formData?.type || formData?.type === "") {
      error = true;
      errors[`type`] = "Champ obligatoire";
    }
    setFormErrors(errors);
    if (error) {
      Object?.keys(errors)?.map((item) => {
        showErrorToaster(`${"champ"} ${label[item]} ${"est Obligatoire"} `);
      });
    } else {
      try {
        // Appeler la méthode du service pour ajouter la formation
        await contactService.addContact(formData);

        // Afficher le toast de succès
        showSuccessToaster("Inscription réussie au contact ");

        // Réinitialiser le champ et l'erreur
        setFormData({
          name: "",
          email: "",
          phone: "",
          type: "",
        });
      } catch (error) {
        // Afficher le toast d'erreur
        showErrorToaster(
          error.response
            ? error.response.data.message
            : "Une erreur est survenue, veuillez réessayer."
        );
      }
    }
  };

  return (
    <section className="contact-section">
      <div className="top-con-cont">
        <div className="container align-items-center d-flex justify-content-center">
          <form className="contact-form " onSubmit={handleSubmit}>
            <h2 className="mb-4">Contactez-Nous</h2>
            <p className="mb-4 mb-5">
              Besoin d’informations ou envie de contribuer à notre mission ?{" "}
              <br />
              Contactez-nous pour faire partie du changement en Afrique.
            </p>
            <div className="form-group mb-3">
              <label
                className={`custom-placeholder ${
                  formData.name && "placeholder-active"
                }`}
                htmlFor="name"
              >
                <span className="text-phone">Nom</span>
                <span className="text-asterisk"> *</span>
              </label>
              <input
                type="text"
                id="name"
                className="form-control"
                value={formData.name}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-group mb-3">
              <label
                className={`custom-placeholder ${
                  formData.email && "placeholder-active"
                }`}
                htmlFor="email"
              >
                <span className="text-phone">Email</span>
              </label>
              <input
                type="email"
                id="email"
                className="form-control"
                value={formData.email}
                onChange={handleChange}
              />
            </div>
            <div className="form-group mb-3">
              <label
                className={`custom-placeholder ${
                  formData.phone && "placeholder-active"
                }`}
                htmlFor="phone"
              >
                <span className="text-phone">Téléphone</span>
                <span className="text-asterisk"> *</span>
              </label>
              <input
                type="tel"
                id="phone"
                className="form-control"
                value={formData.phone}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-group mb-4">
              <select
                id="type"
                className="form-select styled-select"
                value={formData.type}
                onChange={handleChange}
                required
              >
                <option value="" className="default-option" disabled hidden>
                  Comment vous nous avez trouvés ?
                </option>
                <option value="internet" className="custom-option">
                  Internet
                </option>
                <option value="amis" className="custom-option">
                  Amis
                </option>
                <option value="publicité" className="custom-option">
                  Publicité
                </option>
                <option value="autre" className="custom-option">
                  Autre
                </option>
              </select>
            </div>
            <button type="submit" className="btn btn-primary w-100">
              ENVOYEZ
            </button>
            <div className="row ">
              <div className="col-12 col-md-5 d-flex align-items-center contact-item">
                <div className="icon">
                  <img src={phone} alt="phone" />
                </div>
                <div>
                  <h6 className="contact-title">Téléphone</h6>
                  <p className="contact-text">+243 819 003 966</p>
                </div>
              </div>
              <div className="col-12 col-md-6 d-flex align-items-center contact-item">
                <div className="icon">
                  <img src={email} alt="email" />
                </div>
                <div>
                  <h6 className="contact-title">EMAIL</h6>
                  <p className="contact-text">
                    infos@juniormbuyifoundation.com
                  </p>
                </div>
              </div>
            </div>
          </form>
        </div>{" "}
        <div className="sticky-cont">
          <StickyButton />
        </div>
      </div>
    </section>
  );
};

export default ContactForm;
